// extracted by mini-css-extract-plugin
export var promotionLink = "_vd-0";